import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import UIUtilityServiceName, { EnumOption, UIUtilityService } from "../../services/utility/uiUtility.service";
import { apsCommon } from "../../shared/dto/aps.common";
import { apsEnums } from "../../shared/dto/aps.enums";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import CheckListsServiceName, { CheckListsService } from "../../services/checkLists/checkLists.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import { NavigationModel, Plant } from "../../models/navigation";
import { StateParams } from "../../common";
import CheckListInstancesServiceName, { CheckListInstancesService } from "../../services/checkLists/checkListInstances.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import { States, Strings } from "../../shared/config/constant.module";
import LocationsServiceName, { LocationsService, PlantLocation } from "../../services/locations/locations.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import { ICommonLocationReport } from "../reports/commonQueryingReport";
import template from './checkListReport.tpl.html';
import DateUtilityService from "../../services/utility/dateutility.service";

let requires = [CheckListsServiceName, LoaderServiceName, CheckListInstancesServiceName, AuthDataServiceName,
  LocationsServiceName, NavigationServiceName, UIUtilityServiceName, NotifyServiceName];

interface CheckListReportController extends ICommonLocationReport {
  statuses: EnumOption[];
  checkLists: apsCommon.IdAndName[];

  timeZone: string;
  checkListId: string;
  status: apsEnums.CheckListStatus;
  filter: apsEnums.CheckListReportFilter;

  generateReport(): void;
  updateLocation(): void;
  updateStartDate(): void;
  updateEndDate(): void;
  reportData: CheckListReportData;
  searchPerformed: boolean;
}

export interface CheckListReportParams extends StateParams {
  reportPlantId: string;
  locationId: string;
  startDate: string;
  endDate: string;
  checkListId: string;
  status: apsEnums.CheckListStatus;
  filter: apsEnums.CheckListReportFilter;
  autoRun: boolean;
}

export interface CheckListReportData {
  results: apsViewModels.CheckListReportItem[];
  plantId: string;
  shopId: string;
  filter: apsEnums.CheckListReportFilter;
}

class CheckListReportCtrl implements CheckListReportController {
  private checkListsService: CheckListsService;
  private checkListInstancesService: CheckListInstancesService;
  private loaderService: LoaderService;
  private $modal: mm.foundation.modal;
  private $scope: angular.IScope;
  private notifyService: NotifyService;

  plants: Plant[];
  statuses: EnumOption[];
  checkLists: apsCommon.IdAndName[];
  locations: PlantLocation[];

  selectedPlant: Plant;
  selectedLocation: PlantLocation;
  requireLocationSelection: boolean;
  requirePlantSelection: boolean;

  private authDataService: AuthDataService;
  startDate: Date;
  endDate: Date;
  uiStartDate: Date;
  uiEndDate: Date;
  timeZone: string;
  status: apsEnums.CheckListStatus;
  checkListId: string;
  filter: apsEnums.CheckListReportFilter;
  filters: EnumOption[];

  form: any;

  reportData: CheckListReportData;
  searchPerformed: boolean;
  private $q: angular.IQService;
  private locationsService: LocationsService;
  private $timeout: angular.ITimeoutService;
  private $state: angular.ui.IStateService;
  private $stateParams: CheckListReportParams;

  constructor(
    navigationService: NavigationService,
    loaderService: LoaderService,
    checkListsService: CheckListsService,
    checkListInstancesService: CheckListInstancesService,
    uiUtilityService: UIUtilityService,
    $state: angular.ui.IStateService,
    $stateParams: CheckListReportParams,
    authDataService: AuthDataService,
    locationsService: LocationsService,
    notifyService: NotifyService,
    $q: angular.IQService,
    $scope: angular.IScope,
    $timeout: angular.ITimeoutService,
    $modal: mm.foundation.modal) {

    this.requirePlantSelection = true;
    this.requireLocationSelection = false;
    this.$q = $q;
    this.checkListsService = checkListsService;
    this.checkListInstancesService = checkListInstancesService;
    this.loaderService = loaderService;
    this.$modal = $modal;
    this.$scope = $scope;
    this.timeZone = Strings.DEFAULT_TIMEZONE;
    this.$timeout = $timeout;
    this.$state = $state;
    this.$stateParams = $stateParams;

    this.notifyService = notifyService;
    this.authDataService = authDataService;
    this.locationsService = locationsService;

    this.statuses = uiUtilityService.getListOptionsFromEnum(apsEnums.CheckListStatus);
    this.filters = uiUtilityService.getListOptionsFromEnum(apsEnums.CheckListReportFilter, 1);

    var now = moment().add(1, 'hours').startOf('hour');
    this.uiEndDate = now.toDate();
    this.uiStartDate = now.clone().subtract(1, 'days').toDate();
    this.filter = apsEnums.CheckListReportFilter.AllCheckLists;

    var promise = locationsService.initialize().then(() => {
      return navigationService.getNavigation().then((nav: NavigationModel) => {
        this.plants = nav.plants();
        this.selectedPlant = nav.selectedPlant;
        this.updatePlant(true);

        return this.loadState($stateParams).then(() => {
          return this.loadCheckLists();
        });
      });
    });

    loaderService.loadingPromise(promise);
  }

  private loadCheckListTimeout: angular.IPromise<any>;

  private loadCheckLists(throttle?: boolean): angular.IPromise<any> {
    if (this.loadCheckListTimeout) {
      this.$timeout.cancel(this.loadCheckListTimeout);
      this.loadCheckListTimeout = null;
    }

    this.loadCheckListTimeout = this.$timeout(() => {
      var criteria: apsViewModels.CheckListDropDownCriteria = {
        plantId: this.selectedPlant ? this.selectedPlant.id : null,
        locationType: undefined,
        locationId: undefined,
        startDate: this.startDate,
        endDate: this.endDate
      };
      if (this.selectedLocation) {
        criteria.locationType = this.selectedLocation.locationType;
        criteria.locationId = this.selectedLocation.id;
      }
      this.loadCheckListTimeout = null;
      return this.checkListsService.getCheckListsWithData(criteria)
        .then(data => this.checkLists = data);
    }, throttle ? 500 : null);
    return this.loadCheckListTimeout;
  }

  private getPlantId(): string {
    return this.selectedPlant ? this.selectedPlant.id : null;
  }

  private getShopId(): string {
    return (this.selectedLocation
      && this.selectedLocation.locationType === apsEnums.LocationType.Shop)
      ? this.selectedLocation.id : null;
  }

  updatePlant(skipChecklists?: boolean): void {
    this.timeZone = this.selectedPlant ? this.selectedPlant.timeZoneId : Strings.DEFAULT_TIMEZONE;
    this.selectedLocation = undefined;
    this.locations = this.locationsService.getPlantLocations(this.selectedPlant);
    if (skipChecklists !== true) {
      this.loadCheckLists(true);
    }
  }

  updateLocation(): void {
    this.loadCheckLists(true);
  }

  updateStartDate(): void {
    this.loadCheckLists(true);
  }

  updateEndDate(): void {
    this.loadCheckLists(true);
  }

  private setReportData(results: apsViewModels.CheckListReportItem[]) {
    this.reportData = {
      results: results,
      plantId: this.getPlantId(),
      shopId: this.getShopId(),
      filter: this.filter
    };
  }

  private runReport(criteria: apsViewModels.CheckListReportCriteria) {
    this.setReportData(null);

    return this.checkListsService.getCheckListReport(criteria).then(reportItems => {
      this.setReportData(reportItems);
      this.searchPerformed = true;
    }, this.notifyService.handleApiErrors);
  }

  loadState(params: CheckListReportParams): angular.IPromise<any> {
    if (params.reportPlantId && params.locationId && params.locationId !== params.shopId) {
      var plant = _.find(this.plants, { id: params.reportPlantId });
      if (plant) {
        var location = _.find(this.locations, { id: params.locationId });
        if (location) {
          this.selectedPlant = plant;
          this.selectedLocation = location;
        }
      }
    }

    if (!this.selectedLocation) {
      this.selectedLocation = _.find(this.locations, { id: params.shopId });
    }

    DateUtilityService.setReportDates(this, params, this.$timeout);

    if (params.checkListId) {
      this.checkListId = params.checkListId;
    }

    if (params.status !== undefined) {
      var status = _.find(this.statuses, { value: +params.status }); // !!!
      if (status) {
        this.status = status.value;
      }
    }

    if (params.filter !== undefined) {
      var filter = _.find(this.filters, { value: +params.filter }); // !!!
      if (filter) {
        this.filter = filter.value;
      }
    }

    if (params.autoRun) {
      return this.runCheckListReport();
    }

    return this.$q.when();
  }

  saveState(): void {
    var locationId = this.selectedLocation ? this.selectedLocation.id : undefined;
    if (locationId === this.$stateParams.shopId) {
      locationId = undefined;
    }
    var params: CheckListReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: (locationId && this.selectedPlant) ? this.selectedPlant.id : undefined,
      locationId: locationId,
      startDate: this.startDate ? this.startDate.toISOString() : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined,
      checkListId: this.checkListId,
      status: this.status,
      filter: this.filter,
      autoRun: true
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  generateReport(): void {
    if (this.form.$invalid) {
      return;
    }

    this.saveState();

    this.loaderService.loadingPromise(this.runCheckListReport());
  }

  private runCheckListReport(): angular.IPromise<any> {
    var criteria: apsViewModels.CheckListReportCriteria = {
      plantId: this.getPlantId(),
      locationType: undefined,
      locationId: undefined,
      startDate: this.startDate,
      endDate: this.endDate,
      checkListId: this.checkListId,
      status: this.status,
      filter: this.filter
    };
    if (this.selectedLocation) {
      criteria.locationType = this.selectedLocation.locationType;
      criteria.locationId = this.selectedLocation.id;
    }
    return this.runReport(criteria);
  }
}

export default angular.module('aps.controller.checkListReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.CHECKLIST_REPORT,
      url: '/admin/checkLists/report?locationId&startDate&endDate&checkListId&status&filter&autoRun&reportPlantId',
      params: {
        startDate: { dynamic: true },
        endDate: { dynamic: true },
        checkListId: { dynamic: true },
        status: { dynamic: true },
        autoRun: { dynamic: true },
        filter: { dynamic: true },
        reportPlantId: { dynamic: true }
      },
      controller: 'CheckListReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Check List Report',
        v2Uri: 'aps/reports/check-list-report',
        // Carried to v2 so a drill-in from the line sheet lands on the same
        // window and auto-runs, the way loadState did here.
        v2Params: ['startDate', 'endDate']
      }
    });
  })
  .controller('CheckListReportCtrl', CheckListReportCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/checkLists/checkListReport.controller.ts